<template>
    <div v-if="!!report" class="uk-text-center">
        <base-button
            flavor="link"
            size="small"
            @click.prevent="$emit('refresh')"
        >
            <open-icon glyph="refresh" :spin="loading" />
            Refresh
        </base-button>
        <div v-if="!!versions && versions.length" class="uk-form uk-margin-top">
            <small>Available versions: </small><br />
            <form-select
                :id="`report-${report.id}-version`"
                name="version"
                :value="report.version"
                :options="versions"
                empty-label="(Latest)"
                :editable="true"
                :required="false"
                size="small"
                class="uk-display-inline-block uk-margin-small-top"
                @input="$emit('load-version', $event)"
            />
        </div>
        <div v-if="!!exportUrl" class="uk-margin-small-top">
            <a
                :href="exportUrl"
                class="uk-button uk-button-link uk-button-small"
            >
                <open-icon glyph="cloud-download" />
                Export
            </a>
        </div>
    </div>
</template>

<script type="text/javascript">
import FormSelect from "../../ui/FormSelect"
import BaseButton from "../../ui/BaseButton"
import OpenIcon from "../../ui/OpenIcon"

export default {
    components: {
        FormSelect,
        BaseButton,
        OpenIcon
    },
    methods: {
        load_version (event) {
            this.$emit("load-version", event.target.value)
        }
    },
    props: {
        report: {
            type: Object,
            required: true
        },
        versions: {
            type: Array,
            default () {
                return []
            }
        },
        loading: {
            type: Boolean,
            default: false
        },
        exportUrl: {
            type: String,
            default: ""
        }
    }
}
</script>
